export default __webpack_public_path__ + "static/media/dehli1.8561f862.jpg";